import { Button } from '@panwds/react-ui'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { Body } from '@panwds/react-ui'
import { Select } from '@panwds/react-form'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'
import './DropDown.scss'
import { ADD_NEW, SELECT_OR_CREATE, SELECT_TENANT } from '../constants/SubscriptionConstant'

/*
 * Created By sswaminathan
 * Created on Mon Nov 22 2021
 * Created on DropDown.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */


export const ButtonWrapper = styled.div`
  & button {
    justify-content: space-between;
    color: #1D2124;
    height: ${props => (props.hasOwnProperty('height') ? props.height : '40px')};
    width: ${props => (props.hasOwnProperty('width') ? props.width : '400px')};
  }
  .tw-font-lato.tw-text-xs.tw-space-y-1 {
    flex: 1 1;
  }
`

const DropDown = ({
  itemList,
  label,
  desc,
  width,
  height,
  fieldName,
  changeHandler,
  dataTestId,
  customDropDown,
  creatNewOption,
  selectProps,
  errorLabel,
  disable,
  placeholderValue,
  errorMessage,
  createDisplay,
  required,
  customValidation,
  addClassName
}) => {
  const [selectedTenant, setSelectedTenant] = useState({})
  const { getValues, trigger } = useFormContext()
  const selected = getValues(fieldName)

  useEffect(() => {
    setSelectedTenant(selected)
  }, [selected])


  const updateZIndex = useCallback(() => {
    const popOverObj = document.getElementsByClassName('tw-z-30')
    if (popOverObj && popOverObj.length) {
      for (let index = 0; index < popOverObj.length; index++) {
        popOverObj[index].style.zIndex = 1099
      }
    }
  }, [])
  const placeholder = useMemo(() => {
    if (!selectedTenant?.key) {
      return creatNewOption ? SELECT_OR_CREATE : SELECT_TENANT
    }
    return selectedTenant.key === ADD_NEW ? `${selectedTenant?.desc} ${createDisplay}` : selectedTenant.description
  }, [creatNewOption, createDisplay, selectedTenant?.desc, selectedTenant?.description, selectedTenant?.key])

  const validateDropDown = (value) => {
    if (required && !value.id?.length) {
      return errorMessage || `Please select the ${errorLabel ?? fieldName}`
    }
    return true

  }

  const validateCustomDropDown = useCallback((value) => {
    if (required && (!value.key || value.key === '')) {
      return errorMessage || `Please select the ${label}`
    }
    if (customValidation && typeof customValidation === 'function') {
      return customValidation(value)
    }
    return true
  }, [customValidation, errorMessage, label, required])

  return (
    <ButtonWrapper width={width} height={height}>
      {label && <Body size="sm" addClassName="tw-pb-1 tw-pl-1">{label}</Body>}
      <div className="tw-flex tw-flex-row">
        {!customDropDown ? (
          <div className="tw-flex-1"><Select
            addClassName={addClassName || ''}
            items={itemList}
            name={fieldName}
            disabled={disable}
            label={label}
            showLabel={false}
            fitToItemWidth
            menuStyle={{ width: width ? width : '400px' }}
            onOpen={updateZIndex}
            placeholder={placeholderValue}
            register={{
              required: required,
              onChange: (change) => {
                trigger(fieldName)
                if (changeHandler && typeof changeHandler === 'function') {
                  changeHandler(change)
                }
              },
              validate: value => validateDropDown(value)
            }}
            style={{ justifyContent: 'space-between' }}
            {...selectProps}
          /></div>
        ) : (
          <div className="tw-flex-1"><Select
            addClassName={addClassName || ''}
            items={itemList}
            name={fieldName}
            onOpen={updateZIndex}
            label={label}
            showLabel={false}
            fitToItemWidth
            selectedItem={selectedTenant}
            defaultValue={selectedTenant}
            menuStyle={{ width: width ? width : '400px' }}
            //placeholder={placeholder}
            button={(
              <Button
                data-testid={dataTestId}
                fullWidth
                isMenu
              >
                <Body addClassName='tw-truncate'>{placeholder}</Body>
              </Button>
            )}
            register={{
              onChange: (event) => {
                setSelectedTenant(event.target.value)
                if (typeof changeHandler === 'function') {
                  changeHandler(event)
                }
              },
              validate: value => validateCustomDropDown(value)
            }}
            style={{ justifyContent: 'space-between' }}
            {...selectProps}
          /></div>
        )}
        {desc && <div className="tw-flex-1"><Body size="md" addClassName="tw-my-3" appearance="secondary">{desc}</Body></div>}
      </div>
    </ButtonWrapper>
  )
}

DropDown.defaultProps = {
  selectProps: {},
}

export default DropDown
